import OfferingCardBuilder from 'components/OfferingCardBuilder';
import React from 'react';
import { PremiumSessionAggregate } from 'types/premiumSession';

type PremiumSessionCourseCardProps = {
  className?: string;
  premiumSessionAggregate: PremiumSessionAggregate;
};
const PremiumSessionCourseCard = ({
  className = '',
  premiumSessionAggregate,
}: PremiumSessionCourseCardProps) => {
  const sessionSlugForCardWithoutEntry = `${premiumSessionAggregate.content.offering_slug}-s01`;

  return (
    <OfferingCardBuilder
      className={className}
      entry={premiumSessionAggregate.catalogEntry}
      isLivePremiumSessionCourse
      premiumSessionSlug={sessionSlugForCardWithoutEntry}
    >
      <OfferingCardBuilder.Header />
      <OfferingCardBuilder.Body
        premiumSessionAggregate={premiumSessionAggregate}
      />
      <OfferingCardBuilder.Footer />
    </OfferingCardBuilder>
  );
};

export default PremiumSessionCourseCard;
